<script>
import EvaluationComponent from '../../features/details/EvaluationComponent';
export default {
  name: 'EvaluationComponent',
  extends: EvaluationComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Evaluación de Curso"
    width="20%"
    class="evaluation-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Evaluación</legend>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Calificación"
              prop="qualification"
              style="text-align: center;"
            >
              <el-rate v-model="formData.qualification" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Obervaciones"
              prop="observation"
            >
              <el-input
                v-model="formData.observation"
                type="textarea"
                :rows="5"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>